﻿import React, { useContext } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';

import Client_Websites_Errors_Table from '@Elements/Client_Websites_Errors_Table';

export default function ClientWebsite_Errors_Module(): JSX.Element {
    const [t] = useTranslation();
    const { 
        client_websites_with_warnings, 
        client_websites 
    }: context_type = useContext(Context);

    return (
        <section className="Module ClientWebsite_Errors_Module">
            <header className="Module_Header">
                <h2 className="Headline2">{`${t('Text.ClientWebsiteErrors')} (${client_websites_with_warnings?.length})`}</h2>
            </header>
            <Client_Websites_Errors_Table 
                data={client_websites_with_warnings}
                client_websites={client_websites}
            />
        </section>
    );
}